import { render } from "./AdjustmentDataDialog.vue?vue&type=template&id=63f21c0e&scoped=true"
import script from "./AdjustmentDataDialog.vue?vue&type=script&lang=ts"
export * from "./AdjustmentDataDialog.vue?vue&type=script&lang=ts"

import "./AdjustmentDataDialog.vue?vue&type=style&index=0&id=63f21c0e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63f21c0e"

export default script